import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Link } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useTranslation } from 'react-i18next';
import styles from './landingPage.module.css';
import { SITE_URL } from '../../consts';
import { CopigoLogo } from '../ui/copigoLogo/copigoLogo.component';
import { PublicFooter } from '../ui/footer/publicFooter.component';

/**
 * The app's start page - only the way in. Product information lives on the
 * marketing site, which the page links back to.
 */
export const LandingPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Box className={styles.container}>
      <Box className={styles.card}>
        <CopigoLogo className={styles.brandLogo} />

        <Box className={styles.actions}>
          <Button variant="contained" color="success" size="large" fullWidth onClick={() => navigate('/login')}>
            {t('Log in')}
          </Button>
          <Button variant="outlined" color="success" size="large" fullWidth onClick={() => navigate('/register')}>
            {t('Register')}
          </Button>
        </Box>

        <Link href={SITE_URL} underline="hover" className={styles.backLink}>
          <ArrowBackIcon fontSize="small" />
          {t('Back to the Copigo website')}
        </Link>
      </Box>
      <PublicFooter />
    </Box>
  );
};
